<template>
  <div id="app">
    <global-header/>
    <router-view/>
    <!-- todo: delete 
    <div id="nav">
      <router-link to="/">Top</router-link>|
      <router-link to="/about">About</router-link>
    </div>
    -->

    <global-footer/>
  </div>
</template>

<script>
import GlobalHeader from "./components/modules/GlobalHeader";
import GlobalFooter from "./components/modules/GlobalFooter";
export default {
  components: {
    GlobalHeader,
    GlobalFooter
  }
};
</script>

<style lang="scss">
// common CSS
html {
  font-size: 10px;
}
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, Arial, "メイリオ", Meiryo, sans-serif !important;
}
a,
input,
button {
  outline: none;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  font-size: 1.8rem;
  width: 100%;
  overflow: hidden;
  .subpage_headline {
    padding: 80px 0 40px;
    background-color: #fcfdec;
    text-align: center;
    h1 {
      font-size: 40px;
      color: #191919;
      border-top: 2px dotted #191919;
      border-bottom: 2px dotted #191919;
      margin: 0;
      padding: 40px 5%;
      box-sizing: border-box;
      line-height: normal;
      letter-spacing: normal;
      span {
        display: block;
        font-size: 20px;
      }
    }
    @media (max-width: 767px) {
      padding: 0px 0 40px;
      h1{
        font-size: 24px;
        padding: 20px 5%;
        span{
          font-size: 16px;
        }
      }
    }
  }
}
</style>
